import { render, staticRenderFns } from "./auth-page-footer.vue?vue&type=template&id=575feec8&"
import script from "./auth-page-footer.vue?vue&type=script&lang=js&"
export * from "./auth-page-footer.vue?vue&type=script&lang=js&"
import style0 from "./auth-page-footer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../usr/lib/node_modules/@vue/cli-service-global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports